import type { RouteSeo } from '@/shared/seo/types';
import type { ListingSeo } from '@/shared/features/seo/domain/models/Seo';
import { RECENTLY_VIEWED_HEADER } from '@/features/browsing-history/infra/mappers/browsingHistory.mapper';

export const recentlyViewedSeo: RouteSeo = {
  title: 'Recently Viewed | BlueStone',
  description: RECENTLY_VIEWED_HEADER,
  robots: 'noindex,nofollow',
};

/** Client-side document head (PlpSeoHead) — mirrors `recentlyViewedSeo` for SPA navigation. */
export const recentlyViewedListingSeo: ListingSeo = {
  header: RECENTLY_VIEWED_HEADER,
  title: recentlyViewedSeo.title,
  robotsMeta: 'noindex,nofollow',
};
